import { render, staticRenderFns } from "./StorageYard.vue?vue&type=template&id=0240d308&scoped=true&"
import script from "./StorageYard.vue?vue&type=script&lang=js&"
export * from "./StorageYard.vue?vue&type=script&lang=js&"
import style0 from "./StorageYard.vue?vue&type=style&index=0&id=0240d308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0240d308",
  null
  
)

export default component.exports